const mcuTatDetailRoutes = [
    {
        path: '/mcu-tat-detail',
        name: 'mcuTatDetail',
        children: [
            {
                path: '',
                name: 'mcuTatDetailList',
                component: () => import('@/modules/mcu_tat_detail/list/List.vue'),
                meta: {
                    resource: 'bookings',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'MCU TAT Detail',
                    breadcrumbs: [{ title: 'MCU TAT Detail', routeName: 'mcuTatDetailList' }]
                }
            }
        ]
    }
]

export default mcuTatDetailRoutes
